// Convención de archivo para tickets cerrados -- ver TICKETS-API.md
// § "Archivero (convención de UI)". Un ticket "cerrado" hace más de
// ARCHIVE_AFTER_DAYS se deja de mostrar en las pestañas normales y solo
// aparece en Archivero, para que la lista del día a día no se llene de
// historial viejo. Es puramente de presentación (front-end) -- OACS no
// tiene concepto de "archivado", el ticket sigue existiendo igual.
import type { Ticket } from "../../services/ticketsService";

export const ARCHIVE_AFTER_DAYS = 30;

export function isArchivedTicket(ticket: Ticket): boolean {
  if (ticket.status !== "cerrado" || !ticket.resolved_at) return false;
  const ms = Date.now() - new Date(ticket.resolved_at).getTime();
  return ms > ARCHIVE_AFTER_DAYS * 24 * 60 * 60 * 1000;
}

// Separa una lista de tickets en { activos, archivados } según la regla
// de arriba. `activos` conserva el orden original (incluye todo lo que
// no está cerrado, más los cerrados recientes).
export function splitArchived(tickets: Ticket[]): { activos: Ticket[]; archivados: Ticket[] } {
  const activos: Ticket[] = [];
  const archivados: Ticket[] = [];
  for (const t of tickets) {
    (isArchivedTicket(t) ? archivados : activos).push(t);
  }
  return { activos, archivados };
}
